module.exports = __webpack_public_path__ + "img/Mariam Adeyela_Data Analyst.91bdc6ea.jpg";